// import slick from "slick-carousel";
let sliderClass = "j-tabbed-content--slick";

/**
 * initializeBlock
 *
 * All JS to load on the block page goes here.
 *
 * @date    15/4/19
 * @since   1.0.0
 *
 * @param   object $block The block jQuery element.
 * @param   object attributes The block attributes (only available when editing).
 * @return  void
 */
var initializeBlock = function($block, $attributes) {
	let elem = $block;
	if (!$block.hasClass(sliderClass)) {
		elem = $block.find("." + sliderClass);
	}
	elem.each(function() {
		$(this).slick({
			'slide' : '.tds-tabbed-content--slide',
			'rows' : 0,
			'slidesToShow' : 1,
			'slidesToScroll' : 1,
			'infinite' : true,
			'speed' : 300,
			'dots' : true,
			'arrows' : false,
			'autoplay' : false,
			'fade' : true,
			'adaptiveHeight' : true,
			'draggable' : false,
			customPaging: function(slider, i) {
				return '<span class="font-heading-5">' + $(slider.$slides[i]).attr('title') + '</span>';
			},
		});
	});
};


// Initialize each block on page load (front end).
$(document).ready(function() {
	$("." + sliderClass).each(function() {
		initializeBlock($(this), false);
	});
});

// Initialize dynamic block preview (editor).
if (window.acf) {
	window.acf.addAction("render_block_preview/type=tabbed-content", initializeBlock);
}